import { cloneDeep, isEqual } from 'lodash';
import BaseDropdown from '../../base/dropdowns/dropdown';

import '../../base/dropdowns/dropdown.scss';

class MultiselectDropdown extends BaseDropdown {
  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.items, this.props.items)) {
      const options = this.getSelectedOptions(this.props.items);
      this.setState({ options });
    }

    if (!isEqual(prevProps.label, this.props.label)) {
      this.setState({ label: this.props.label });
    }
  }

  update() {
    const options = this.getSelectedOptions(this.state[this.type]);
    this.props.updateOptions(options);
  }

  resetColumns(selectedState) {
    // Create deep copy to prevent mutating state object directly
    let options = cloneDeep(this.state[this.type]);
    options = options
      .filter(option => !option.hidden)
      .map(option => {
        option.selected = selectedState;
        return option;
      });
    this.setState({ [this.type]: options });
  }

  getSelectedOptions(options) {
    // PubDropdown has a default state of none selected, we don't want to default to all selected
    if (this.type === 'publishers') {
      return options;
    }

    let newOptions = cloneDeep(options);
    // If no options selected, select all options instead
    if (newOptions && !newOptions.filter(option => option.selected).length) {
      newOptions = newOptions.map(option => {
        option.selected = true;
        return option;
      });
    }

    return newOptions;
  }
}

class StatusDropdown extends MultiselectDropdown {
  constructor(props) {
    super(props);

    this.type = 'statuses';
    this.identifierField = 'name';
    this.hasSearch = false;

    this.state = {
      statuses: this.props.items,
      opened: false,
      focusIndex: null,
      label: 'Campaign Status',
    };
  }
}

class TypeDropdown extends MultiselectDropdown {
  constructor(props) {
    super(props);

    this.type = 'types';
    this.identifierField = 'name';
    this.hasSearch = false;

    this.state = {
      types: this.props.items,
      opened: false,
      focusIndex: null,
      label: 'Campaign Type',
    };
  }
}

class PublisherDropdown extends MultiselectDropdown {
  constructor(props) {
    super(props);

    this.type = 'publishers';
    this.hasSearch = true;
    this.identifierField = 'name';

    this.state = {
      publishers: this.props.items,
      opened: false,
      focusIndex: null,
      label: this.props.label,
    };
  }
}

export { StatusDropdown, TypeDropdown, PublisherDropdown };
